import { useState, useEffect } from 'react';

// 目前有些純訂閱方案的建築物，例如洗車訂閱，不需要顯示停車位資訊
// 注意，目前雖然是分辨 subscription only 但其實有些文案或 LINE@ 是寫死洗車，所以未來要擴展要 refactor
export const SUBSCRIPTION_ONLY_BUILDING_IDS = [
  '4ce57e3e-4f2d-4412-8b4f-ca364e99d1ac', // 洗車訂閱
];

// 因為有些公有停車場他的月租登記需要抽籤或是流程不一樣，所以需要特別處理
const TPE_GOV_BUILDING_IDS = [
  'ad111d3c-fbeb-4e62-95d0-6137dce81ab8', // USPACE正氣橋下平面停車場
  'ab1c63d0-8c86-4b18-b7fa-3dc8f26d6f0c', // USPACE長春路龍江路臨時平面停車場
  '357d15cc-2a14-44b8-9aa9-d4933cc6171d', // USPACE昆陽捷運站旁平面停車場
  '6ca6af48-f027-4651-9567-818c932de910', // USPACE吉祥平面停車場
];

const HEADQUARTER_SUPPORT_BUILDING_IDS = [
  'efc77487-4907-4bfc-a451-1488dd234dd3', // 神岡台灣氣球博物館
  '371454a7-3b92-44ae-8a6c-7de906bee018', // 福悠停車場一場
  '6bff0a9b-378f-4b05-a782-c4bc33e0fac6', // USPACE大里益民站
];

// 這些要到停管處抽籤
const PMA_GOV_BUILDING_IDS = [
  'dce5dd6c-0daf-4f5d-a20f-7482eff7cda7', // USPACE青年一期社會住宅地下停車
  'f6c83353-6310-4bc0-90b1-99b9bcf09892', // USPACE健康1區社會住宅地下停車場
  'f5da3e5b-84a2-4da6-baba-9043ccef8c40', // USPACE健康2區社會住宅地下停車場
  '357d15cc-2a14-44b8-9aa9-d4933cc6171d', // USPACE昆陽捷運站旁平面停車場
];

export function useSubscriptionType(buildingId) {
  const [subscriptionType, setSubscriptionType] = useState('regular');
  const [isHeadquarterSupport, setIsHeadquarterSupport] = useState(false);
  const [isPmaGov, setIsPmaGov] = useState(false);

  useEffect(() => {
    if (SUBSCRIPTION_ONLY_BUILDING_IDS.includes(buildingId)) {
      setSubscriptionType('subscription_only');
    } else if (TPE_GOV_BUILDING_IDS.includes(buildingId)) {
      setSubscriptionType('tpe_gov');
    } else {
      setSubscriptionType('regular');
    }

    if (PMA_GOV_BUILDING_IDS.includes(buildingId)) {
      setIsPmaGov(true);
    }

    // 處理是否為總部客服處理
    if (HEADQUARTER_SUPPORT_BUILDING_IDS.includes(buildingId)) {
      setIsHeadquarterSupport(true);
    }
  }, [buildingId]);

  return {
    subscriptionType,
    isSubscriptionOnly: subscriptionType === 'subscription_only',
    isTpeGov: subscriptionType === 'tpe_gov',
    isRegular: subscriptionType === 'regular',
    isHeadquarterSupport,
    isPmaGov,
  };
}
